import audioSvg from "Content/images/documentContentType/audio.svg";
import textSvg from "Content/images/documentContentType/text.svg";
import videoSvg from "Content/images/documentContentType/video.svg";
import { DOCUMENT_CONTENT_TYPE } from "./documentContentType";
export default {
    [DOCUMENT_CONTENT_TYPE.TEXT]: textSvg,
    [DOCUMENT_CONTENT_TYPE.AUDIO]: audioSvg,
    [DOCUMENT_CONTENT_TYPE.VIDEO]: videoSvg
};
